var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "yxtbiz-dept-tree-v3",
    },
    [
      _c(
        "div",
        { staticClass: "yxtbiz-dept-tree-v3-search" },
        [
          _c(
            "yxt-row",
            { attrs: { type: _vm.selectorAlign ? "" : "flex" } },
            [
              _vm.enableGroupCorp && _vm.visibleOrgSelector
                ? _c("yxtbiz-group-org-select", {
                    staticClass: "mr12 mb12",
                    style: _vm.selectorAlign ? "width: 100%" : "",
                    attrs: {
                      selectFirst: true,
                      setCurrentOrg: _vm.setCurrentOrg,
                      functionCode: _vm.functionCode,
                      dataPermissionCode: _vm.dataPermissionCode,
                      clearable: false,
                      targetOrgId: _vm.targetOrgId,
                      visibleOrgIds: _vm.visibleOrgIds,
                      disabled: _vm.disabled,
                      size: "small",
                    },
                    on: { change: _vm.handleOrgChange },
                  })
                : _vm._e(),
              _c("yxt-input", {
                ref: "input",
                staticClass: "yxtbiz-dept-tree__input",
                staticStyle: { "max-width": "320px" },
                attrs: {
                  placeholder: _vm.placeholder,
                  size: "small",
                  searchable: "",
                },
                on: { search: _vm.filter },
                model: {
                  value: _vm.filterText,
                  callback: function ($$v) {
                    _vm.filterText = $$v
                  },
                  expression: "filterText",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-dept-tree-v3-bread-crumb" },
        [
          _c("BreadCrumb", {
            attrs: { "bread-crumb-list": _vm.breadCrumbList },
            on: { click: _vm.handleBreadCrumb },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yxtbiz-dept-tree-v3-teee-content" },
        [
          _c("TreeList", {
            attrs: { "tree-list": _vm.treeList },
            on: { next: _vm.handleNext },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }